<div class="description">
  <div>Explore an open ecosystem that allows users to create 360° solutions.</div>
  <div class="bold">Without limits to create beautiful experiences in a simple, intuitive and powerful way.</div>
</div>
<div class="disclaimer">This application is provided for development and testing purposes only</div>
